;(function () {
  let controller = null

  const SECTION = 'mainCollectionFilters'
  const EVENTS = {
    formChange: 'mainCollectionFilters:formChange',
    facetRemoval: 'mainCollectionFilters:facetRemoval',
    render: 'mainCollectionFilters:renderUpdate',
  }

  const setPageUpdate = ({ requestURL }) => {
    window.history.pushState({}, '', requestURL)

    SAXX.App.emit(SAXX.Events.CollectionFilterEvent, null, {
      section: SECTION,
    })

    mainCollectionFiltersUrlEvent({ requestURL })
  }

  const mainCollectionFiltersUrlEvent = (
    { requestURL = new URL(window.location) } = {
      requestURL: new URL(window.location),
    },
  ) => {
    if (controller) {
      controller.abort()
    }

    requestURL.searchParams.set('section_id', 'main-collection-filters')

    controller = new AbortController()
    const signal = controller.signal
    fetch(requestURL.toString(), { signal })
      .then((res) => res.text())
      .then((response) => {
        const section = new DOMParser().parseFromString(response, 'text/html')

        requestURL.searchParams.delete('section_id')

        SAXX.App.emit(EVENTS.render, null, {
          facets: section.querySelector('#main-collection-filters--facets')
            .innerHTML,
          paramGroups: section.querySelectorAll('fieldset[data-group]'),
          inputs: section.querySelectorAll('input'),
          titles: section.querySelectorAll('legend[data-title-id]'),
          viewItemsText: section.querySelector(
            '#main-collection-filter--submit',
          ).innerHTML,
          url: requestURL,
        })

        controller = null
        SAXX.App.mount()
      })
      .catch((e) => {
        if (e.name === 'AbortError') return
        console.error(e)
      })
  }

  const components = {
    mainCollectionFilters: SAXX.Init.Component((node, ctx) => {
      ctx.on(SAXX.Events.CollectionFilterEvent, (_, details) => {
        if (details.section !== SECTION) mainCollectionFiltersUrlEvent()
      })

      ctx.on(EVENTS.render, (_, details) => {
        details.inputs.forEach((input) => {
          if (!input.id) return

          const inputToUpdate = document.getElementById(input.id)
          if (!inputToUpdate) return

          inputToUpdate.disabled = input.disabled
          inputToUpdate.checked = input.checked
          const container = inputToUpdate.closest('.filter-input-container')

          if (container) {
            container.toggleAttribute('inert', !!input.disabled)
            container.toggleAttribute('data-checked', !!input.checked)
          }
        })

        details.titles.forEach((title) => {
          const id = title.getAttribute('data-title-id')
          const label = node.querySelector(`span[data-title-id="${id}"]`)
          if (!label) return

          label.innerHTML = title.innerHTML
        })

        details.paramGroups.forEach((group) => {
          const groupId = group.getAttribute('data-group')
          const size = Number(group.getAttribute('data-visible-size'))
          const accordion = node.querySelector(`[data-group="${groupId}"]`)
          if (!accordion) return

          accordion.setAttribute('data-visible-size', size)
          accordion.classList.toggle('has--see-more', size > 7)
        })
      })

      node.addEventListener('change', () => {
        const requestURL = new URL(node.action)
        const formData = new FormData(node)

        for (const [key, value] of formData.entries()) {
          requestURL.searchParams.append(key, value)
        }
        setPageUpdate({ requestURL })
      })

      window.addEventListener('popstate', () => {
        mainCollectionFiltersUrlEvent()
      })
    }),
    mainCollectionFilterSeeMore: SAXX.Init.Component((node) => {
      node.addEventListener('click', () => {
        const relatedAccordion = node.closest('.filter-list--accordion')
        relatedAccordion.classList.toggle('is--expanded')
        node.innerHTML =
          relatedAccordion.classList.contains('is--expanded') ?
            SAXX.Localization.ShowLess
          : SAXX.Localization.ShowMore
      })
    }),

    mainCollectionFiltersSubmitButton: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.render, (_, details) => {
        node.innerHTML = details.viewItemsText
      })

      node.addEventListener('click', (e) => e.preventDefault())
    }),
    mainCollectionFiltersClearAll: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', (e) => {
        e.preventDefault()
        const requestURL = new URL(
          window.location.origin + window.location.pathname,
        )

        setPageUpdate({ requestURL })
      })
    }),
    mainCollectionFiltersFacets: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.render, (_, details) => {
        node.innerHTML = details.facets
      })
    }),
    mainCollectionFiltersFacet: SAXX.Init.Component((node) => {
      node.addEventListener('click', (e) => {
        e.preventDefault()
        const requestURL = new URL(node.href)
        setPageUpdate({ requestURL })
      })
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
